var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"fill-height":"","row":"","wrap":"","mx-4":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"overflow-x-hidden pr-3 mt-0",staticStyle:{"line-height":"20px","word-wrap":"break-word"},attrs:{"row":"","wrap":""}},[_c('h4',{class:"hover-underline colorBlack1",staticStyle:{"font-size":"18px"},on:{"click":function($event){return _vm.$router.push(("/feed/" + (_vm.itemData.feedId)))}}},[_vm._v("\n        "+_vm._s(_vm.itemData.Content
            ? _vm.itemData.Content.length > 150
              ? _vm.itemData.Content.substring(0, 149) + "..."
              : _vm.itemData.Content
            : "")+"\n      ")])]),_c('v-layout',{staticClass:"mt-2 pr-3 Black",staticStyle:{"line-height":"18px","font-size":"15px"},attrs:{"row":"","wrap":""}},_vm._l(([
          { FullName: 'Ahmet Çümen' },
          { FullName: 'Poyraz Çümen' },
          { FullName: 'Ezgi Çümen' },
          { FullName: 'Cengiz Çümen' } ]),function(User,index){return _c('span',{key:index,staticClass:"mr-3 light-blue--text"},[_vm._v(_vm._s(User.FullName + " "))])}),0),_c('v-layout',{staticClass:"mt-2 pr-3 colorGrey3",staticStyle:{"line-height":"17px","font-size":"15px"},attrs:{"row":"","wrap":""}},_vm._l(([
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' },
          { TagName: 'etiket1' } ]),function(tag,index){return _c('span',{key:index,staticClass:"mr-3"},[_vm._v(_vm._s("#" + tag.TagName))])}),0)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }